import { unregisterPushToken } from './api';

const PUSH_TOKEN_STORAGE_KEY = 'ip4estates_push_token';

export function rememberToken(token: string): void {
  localStorage.setItem(PUSH_TOKEN_STORAGE_KEY, token);
}

/**
 * Unregisters the device's push token from the signed-in member's tenant.
 * The stored key is dropped before the request: a 401 here triggers `signOut()`,
 * which would otherwise find the key again and loop.
 */
export async function unregisterStoredToken(): Promise<void> {
  const token = localStorage.getItem(PUSH_TOKEN_STORAGE_KEY);
  localStorage.removeItem(PUSH_TOKEN_STORAGE_KEY);

  if (!token) return;

  await unregisterPushToken(token).catch(() => { /* non-fatal */ });
}
